import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../_services/authentication.service";
import { Helpers } from "../../helpers";
import { environment } from "../../../environments/environment";
declare let FS: any;

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class LogoutComponent implements OnInit {

    constructor(private _router: Router,
        private _authService: AuthenticationService) {
    }

    ngOnInit(): void {
        Helpers.setLoading(true);
        // reset login status
        this._authService.logout().then(() => {
            if (environment.production) {
                FS.clearUserCookie();
            }
            localStorage.removeItem('currentUser');
            localStorage.removeItem('token');
            this._router.navigate(['/login']);
        }, error => {
            console.error(error);
        })

    }
}


// WEBPACK FOOTER //
// ./src/app/auth/logout/logout.component.ts